<div
  [class]="classes"
  [attr.id]="attributes['id']"
  [attr.aria-label]="attributes['ariaLabel']"
  [attr.data-example]="attributes['dataExample']"
>
  <ng-content></ng-content>
</div>
